import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectedSurveyQuestionOptions } from 'app/teacher-feedback/teacher-feedback-service/selected-survey-question-options';
import { SurveyQuestion } from '../../../teacher-feedback/teacher-feedback-service/survey-question';
import { SurveyQuestionGroup } from '../../../teacher-feedback/teacher-feedback-service/survey-question-group';
import { SurveyQuestionOption } from '../../../teacher-feedback/teacher-feedback-service/survey-question-option';
import { LiveClassFeedbackRatingQuestionTypes } from '../survey-questions-id.enum';

@Component({
  selector: 'lp2-liveclass-survey',
  templateUrl: './liveclass-survey.component.html',
  styleUrls: ['./liveclass-survey.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LiveclassSurveyComponent),
      multi: true,
    },
  ],
})
export class LiveclassSurveyComponent implements ControlValueAccessor {
  @Input() set questions(surveyQuestions: SurveyQuestionGroup[]) {
    const surveyQuestion = surveyQuestions[0].questions.find(question => question.id === LiveClassFeedbackRatingQuestionTypes.REASONS);
    this._questions = surveyQuestion.options;
    this.parentQuestion = surveyQuestion;
    this.headerText = surveyQuestions[0].questions.find(question => question.id === LiveClassFeedbackRatingQuestionTypes.MAIN).question;
  }

  @Input()
  public isSaving: boolean;

  @Input()
  public isBlocked: boolean;

  @Output()
  public onSubmit = new EventEmitter<SelectedSurveyQuestionOptions>();

  public _questions: SurveyQuestionOption[] = [];
  public selectedQuestionOptionControl = new FormControl();
  public textAreaControl = new FormControl(null);
  public headerText: string;
  public value: SelectedSurveyQuestionOptions;

  private parentQuestion: SurveyQuestion | null = null;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  public get isButtonDisabled(): boolean {
    if (!this.value || !this.value.profileQuestionOptionId) {
      return true;
    }

    if (
      this.value.profileQuestionOptionId === LiveClassFeedbackRatingQuestionTypes.OTHER &&
      !this.value.optionalText
    ) {
      return true;
    }

    return false;
  }

  constructor(private readonly cdRef: ChangeDetectorRef) {
    this.selectedQuestionOptionControl.valueChanges.subscribe((value) => {
      this.updateValue({ profileQuestionOptionId: Number(value) });
    });

    this.textAreaControl.valueChanges.subscribe((value) => {
      this.updateValue({ optionalText: value });
    });
  }

  public writeValue(value: SelectedSurveyQuestionOptions): void {
    this.value = value;

    if (value && value.optionalText) {
      this.textAreaControl.setValue(value.optionalText);
    }

    if (value && value.profileQuestionOptionId) {
      this.selectedQuestionOptionControl.setValue(value.profileQuestionOptionId, { emitEvent: false })
    }

    this.cdRef.detectChanges();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isBlocked = isDisabled;
    this.cdRef.detectChanges();
  }

  public updateValue(value: Partial<SelectedSurveyQuestionOptions>): void {
    if (this.isBlocked) {
      return;
    }

    this.value = {
      ...this.value,
      ...value,
      profileQuestionId: this.parentQuestion.id,
    };

    if (
      this.value &&
      !this.value.profileQuestionOptionId &&
      this.textAreaControl.value
    ) {
      this.selectedQuestionOptionControl.setValue(LiveClassFeedbackRatingQuestionTypes.OTHER);
    }

    this.onChange(this.value);
    this.onTouched();
    this.cdRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-liveclass-feedback-modal/liveclass-survey/liveclass-survey.component.ts